import * as React from "react";
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {AppBar, Card} from "@mui/material";
import properties from "constants/ApplicationConstants";

export default function AdminPermissions() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <Card>
            <MDBox pt={2} px={3} pb={4} sx={{borderRadius: "10px", border: "1px solid #D3D3D3"}}>
              <Typography
                variant="h6"
                sx={{textAlign: "center", fontFamily: properties.fontFamily, fontSize: "40px"}}
              >
                Under Development
              </Typography>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
